// Shared pure rules. Keep CommonJS exports compatible with the sealed CRA bundle.
const defaults = { dailyReminder: false, wheelReminder: false, dailyReminderTime: '19:00', wheelReminderTime: '21:00', remindersConfigured: false };
const isReminder = kind => kind === 'dailyReminder' || kind === 'wheelReminder';
const validTime = value => typeof value === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
const validTarget = (kind, target) => !isReminder(kind) || typeof target === 'string' && new RegExp('^' + (kind === 'dailyReminder' ? 'daily' : 'wheel') + ':\\d{4}-\\d{2}-\\d{2}$').test(target);
function reminderText(event) {
 const daily = event.kind === 'dailyReminder';
 const copy = daily ? [
 ['Bugünün harfleri seni bekliyor', 'Günün Kelimo’suna henüz başlamadın. Kendi çözümünü bulmaya ne dersin?'],
 ['Bir tahta, yepyeni olasılıklar', 'Bugünün Kelimo’su hazır. Harflerini yerleştir, kendi rekoruna yaklaş.'],
 ['Bugün kelimeler sende', 'Günün Kelimo’sunu henüz çözmedin. Kısa bir kelime molası ver.']
 ] : [
 ['Bugünkü çark hakkın duruyor', 'Şans Çarkı’nı bugün henüz çevirmedin. Ödülünü keşfet.'],
 ['Çarkta bugün sana ne çıkacak?', 'Bugünkü ücretsiz çark hakkını henüz kullanmadın.'],
 ['Kelimo’da küçük bir sürpriz', 'Bugünün Şans Çarkı seni bekliyor. Çevirmek için uygulamayı aç.']
 ];
 const day = String(event.gameId || '').slice(-10);
 const index = [...day].reduce((n,c) => n + c.charCodeAt(0), 0) % copy.length;
 return { title: 'Kelimo · ' + copy[index][0], body: copy[index][1] };
}
module.exports = { defaults, isReminder, validTime, validTarget, reminderText };
